<template>
  <div class="certiciateorder">

    <h1 id="formTitle">Review a submitted death record</h1>
    <!-- <ClosureNotice/> -->
    <p>Funeral directors, cemeteries or crematoriums can request a review of a death registration or disposal notice that
      has been submitted to change incorrect or missing information.</p>
    <p>When you submit a request, an email will be sent to you and to the correct team in our office for action.</p>
    <p>For most corrections you will need to provide supporting documents and after we have reviewed your request; we will
      let you know whether a correction fee of $23.40 is payable.</p>
    <p>If asking for a correction to an existing death certificate you can upload supporting documents when submitting
      your request to us.</p>
    <p>Make sure documents are scanned, and saved onto your desktop as a PDF, JPEG, TIFF or PNG with a maximum file size
      no more than 20MB. Do not use special characters in the file name, such as apostrophes.</p>

    <h2 id="request">Request a review of a submitted death record</h2>
    <p>Fill in the details below to request a review of a death registration, disposal notice or certificate and a
      registry officer will contact you.</p>
    <p></p>
    <p><strong>Please note:</strong> We reply to review requests within 10 business days.</p>

    <form @submit="submitForm" id="submitForm">

      <ol class="questions">
        <li class="section">
          <fieldset>
            <legend>
              <span class="h3">Your contact details</span>
            </legend>
            <div class="status info">
              By using the following online service and providing an email address and contact number, you consent to the
              use of these details by the Registry of Births, Deaths and Marriages (RBDM) to send you a copy of the
              request and to contact you about this request. It is your responsibility to ensure that you
              nominate a secure email address for RBDM to send the details to. It is your responsibility to ensure the
              security of that information when received.
            </div>
            <ul class="questions">
              <li>
                <label for="contactFirstName"> <span class="label">First name</span> <abbr class="required"
                    title="(required)">*</abbr></label>
                <input id="contactFirstName" autocomplete="given-name" v-model="form.contactFirstName"
                  name="attributes.contactFirstName" type="text" required="required" class="stretchWidth" maxlength="255">
              </li>
              <li>
                <label for="contactFamilyName"> <span class="label">Family name</span> <abbr class="required"
                    title="(required)">*</abbr></label>
                <input id="contactFamilyName" autocomplete="family-name" v-model="form.contactFamilyName"
                  name="attributes.contactFamilyName" type="text" required="required" class="stretchWidth"
                  maxlength="255">
              </li>
              <li>
                <label for="contactOrganisationName"> <span class="label">Name of organisation or business you
                    represent</span> <abbr class="required" title="(required)">*</abbr></label>
                <input id="contactOrganisationName" autocomplete="organization" v-model="form.contactOrganisationName"
                  name="attributes.contactOrganisationName" type="text" required="required" class="stretchWidth"
                  maxlength="255">
              </li>
              <li class="applicantPreferredContactEmail">
                <label for="applicantPreferredContactEmail">
                  <span class="label">Email</span>
                  <abbr class="required" title="(required)">*</abbr>
                </label>
                <input id="applicantPreferredContactEmail" autocomplete="email"
                  v-model="form.applicantPreferredContactEmail" name="attributes.applicantPreferredContactEmail"
                  type="email" required="required" class="stretchWidth" maxlength="255">
              </li>
              <li class="applicantPreferredContactMobile">
                <label for="applicantPreferredContactMobile">
                  <span class="label">Contact number</span>
                  <abbr class="required" title="(required)">*</abbr>
                  <small class="hint">If you do not have a mobile number, provide a daytime phone number.</small>
                </label>
                <input id="applicantPreferredContactMobile" autocomplete="tel"
                  v-model="form.applicantPreferredContactMobile" name="attributes.applicantPreferredContactMobile"
                  type="tel" pattern=".{10,}" required="required" class="stretchWidth" maxlength="15">
              </li>
            </ul>
          </fieldset>
        </li>
        <li>
          <fieldset>
            <legend id="attributes.typeOfDeathRecordToReview">
              <span class="h3">What type of record needs to be reviewed?</span>
              <abbr class="required" title="(required)">*</abbr>
            </legend>
            <ul class="choices">
              <li>
                <input id="correctionToExistingDeathCertificate" v-model="form.typeOfDeathRecordToReview"
                  value="correctionToExistingDeathCertificate" name="attributes.typeOfDeathRecordToReview" type="radio"
                  required="">
                <label for="correctionToExistingDeathCertificate">Correction to existing death certificate</label>
              </li>
              <li>
                <input id="changePendingDeathRegistration" v-model="form.typeOfDeathRecordToReview"
                  value="changePendingDeathRegistration" name="attributes.typeOfDeathRecordToReview" type="radio"
                  required="">
                <label for="changePendingDeathRegistration">Make a change to a pending death registration</label>
              </li>
              <li>
                <input id="correctionToDisposalNotice" v-model="form.typeOfDeathRecordToReview"
                  value="correctionToDisposalNotice" name="attributes.typeOfDeathRecordToReview" type="radio" required="">
                <label for="correctionToDisposalNotice">Correction to disposal notice</label>
              </li>
            </ul>
          </fieldset>
        </li>
        <li v-if="form.typeOfDeathRecordToReview == 'correctionToExistingDeathCertificate'">
          <fieldset>
            <legend>
              <span class="label">Are the delivery details still the same?</span>
              <abbr class="required" title="(required)">*</abbr>
            </legend>
            <ul class="choices compact">
              <li>
                <input id="deliveryDetailsTheSame-yes" v-model="form.deliveryDetailsTheSame" value="true"
                  name="attributes.deliveryDetailsTheSame" type="radio" required="">
                <label for="deliveryDetailsTheSame-yes">Yes</label>
              </li>
              <li>
                <input id="deliveryDetailsTheSame-no" v-model="form.deliveryDetailsTheSame" value="false"
                  name="attributes.deliveryDetailsTheSame" type="radio" required="">
                <label for="deliveryDetailsTheSame-no">No</label>
              </li>
            </ul>
          </fieldset>
          <fieldset v-if="form.deliveryDetailsTheSame == 'false'">
            <ol class="questions">
              <li class="stretchWidth">
                <label id="deliveryFirstName-label" for="deliveryFirstName">
                  <span class="label">First name</span> <abbr class="required" title="(required)">*</abbr>
                </label>
                <input id="deliveryFirstName" autocomplete="given-name" required="required" class="stretchWidth"
                  type="text" value="" size="40" v-model="form.deliveryFirstName" name="attributes.deliveryFirstName"
                  maxlength="255">
              </li>
              <li class="stretchWidth">
                <label id="deliveryMiddleName-label" for="deliveryMiddleName">
                  <span class="label">Middle name(s)</span>
                </label>
                <input id="deliveryMiddleName" autocomplete="middle-name" class="stretchWidth" type="text" value=""
                  size="40" v-model="form.deliveryMiddleName" name="attributes.deliveryMiddleName" maxlength="255">
              </li>
              <li class="stretchWidth">
                <label id="deliveryFamilyName-label" for="deliveryFamilyName">
                  <span class="label">Family name</span> <abbr class="required" title="(required)">*</abbr>
                </label>
                <input id="deliveryFamilyName" autocomplete="family-name" required="required" class="stretchWidth"
                  type="text" value="" size="40" v-model="form.deliveryFamilyName" name="attributes.deliveryFamilyName"
                  maxlength="255">
              </li>
            </ol>
            <strong>Postal address</strong>
            <ol class="questions compact">
              <li class="stretchWidth">
                <label id="deliveryLine1-label" for="deliveryLine1">
                  <span class="label">Address line 1</span> <abbr class="required" title="(required)">*</abbr>
                </label>
                <input id="deliveryLine1" autocomplete="address-line1" required="required" class="stretchWidth"
                  type="text" value="" size="40" v-model="form.deliveryLine1" name="attributes.deliveryLine1"
                  maxlength="255">
              </li>
              <li class="stretchWidth">
                <label id="deliveryLine2-label" for="deliveryLine2">
                  <span class="label">Address line 2</span>
                </label>
                <input id="deliveryLine2" autocomplete="address-line2" class="stretchWidth" type="text" value="" size="40"
                  v-model="form.deliveryLine2" name="attributes.deliveryLine2" maxlength="255">
              </li>
              <li class="stretchWidth">
                <label id="deliveryLine3-label" for="deliveryLine3">
                  <span class="label">Address line 3</span>
                </label>
                <input id="deliveryLine3" autocomplete="address-line3" class="stretchWidth" type="text" value="" size="40"
                  v-model="form.deliveryLine3" name="attributes.deliveryLine3" maxlength="255">
              </li>
              <li class="">
                <ol class="questions compact">
                  <li>
                    <label id="deliverySuburb-label" for="deliverySuburb">
                      <span class="label">City, town or suburb</span> <abbr class="required" title="(required)">*</abbr>
                    </label>

                    <input class="" autocomplete="address-level2" required="required" id="deliverySuburb" type="text"
                      value="" size="15" v-model="form.deliverySuburb" name="attributes.deliverySuburb" maxlength="255">
                  </li>
                  <li>
                    <label id="deliveryState-label" for="deliveryState">
                      <span class="label">State or territory</span> <abbr class="required" title="(required)">*</abbr>
                    </label>

                    <input class="" autocomplete="address-level1" required="required" id="deliveryState" type="text"
                      value="" size="5" v-model="form.deliveryState" name="attributes.deliveryState" maxlength="255">
                  </li>
                  <li>
                    <label id="deliveryPostcode-label" for="deliveryPostcode">
                      <span class="label">Postcode</span> <abbr class="required" title="(required)">*</abbr>
                    </label>
                    <input class="" autocomplete="postal-code" required="required" id="deliveryPostcode" type="tel"
                      pattern="[0-9]*" novalidate value="" size="5" v-model="form.deliveryPostcode"
                      name="attributes.deliveryPostcode" maxlength="10">
                  </li>
                  <li class="stretchWidth">
                    <label id="deliveryCountry-label" for="deliveryCountry">
                      <span class="label">Country</span>
                      <small class="hint">Only include country if not Australia.</small>
                    </label>

                    <input class="stretchWidth" autocomplete="country" id="deliveryCountry" type="text" value="" size="30"
                      v-model="form.deliveryCountry" name="attributes.deliveryCountry" maxlength="255">
                  </li>
                </ol>
              </li>
            </ol>
          </fieldset>
        </li>
        <li>
          <fieldset>
            <legend>
              <span class="h3">Details of record to be reviewed</span>
              <p>
                <strong>Please note:</strong> We reply to review requests within 10 business days.
              </p>
            </legend>

            <span class="label">Name of person who passed away</span>
            <ol class="questions">
              <li>
                <label for="event-first-name">
                  <span class="label">First name</span>
                  <abbr title="(required)" class="required">* </abbr>
                </label>
                <input class="stretchWidth" required="true" id="event-first-name" type="text" value="" size="30"
                  v-model="form.deceasedFirstName" name="attributes.deceasedFirstName" maxlength="255">
              </li>
              <li>
                <label for="event-middle-name">
                  <span class="label">Middle name(s)</span>
                </label>
                <input class="stretchWidth" id="event-middle-name" type="text" value="" size="30"
                  v-model="form.deceasedMiddleNames" name="attributes.deceasedMiddleNames" maxlength="255">
              </li>
              <li>
                <label for="event-family-name">
                  <span class="label">Family name</span>
                  <abbr title="(required)" class="required">* </abbr>
                </label>
                <input class="stretchWidth" required="true" id="event-family-name" type="text" value="" size="30"
                  v-model="form.deceasedFamilyName" name="attributes.deceasedFamilyName" maxlength="255">
              </li>
              <li>
                <label for="event-date-of-death">
                  <span class="label">Date of death</span>
                  <abbr title="(required)" class="required">* </abbr>
                </label>
                <input id="event-date-of-death" required="true" type="date" value="" size="10"
                  v-model="form.deceasedDateOfDeath" name="attributes.deceasedDateOfDeath" maxlength="10">
              </li>
              <li>
                <label for="referenceNumber">
                  <span class="label">Web batch or death registration number</span>
                  <abbr title="(required)" class="required">* </abbr>
                </label>
                <input id="referenceNumber" required="true" type="text" value="" size="30"
                  v-model="form.deathRegistrationReference" name="attributes.deathRegistrationReference" maxlength="30">
              </li>
            </ol>
          </fieldset>
        </li>
        <li class="">
          <fieldset>
            <ul class="questions">
              <li>
                <label for="informationIncorrectOrMissing">
                  <span class="label">What information is incorrect or missing?</span>
                  <abbr class="required" title="(required)">*</abbr>
                  <small class="hint">Please advise what is incorrect or missing and what it should be.</small>
                </label>
                <textarea id="informationIncorrectOrMissing" required="" class="stretchWidth" rows="10"
                  v-model="form.informationIncorrectOrMissing" name="attributes.informationIncorrectOrMissing"></textarea>
              </li>
            </ul>
          </fieldset>
        </li>
        <li v-if="requiresUpload()">
          <fieldset>
            <legend>
              <span class="h3">Upload your documentation</span>
              <div class="status info">
                <p>Supported file types: PDF, JPEG, PNG. </p>
                <p>The maximum file size is 20 MB. </p>
                <p>Do not use special characters (such as apostrophes) and accents in file names.</p>
              </div>
            </legend>

            <ul class="questions">
              <li>
                <legend class="attachDocument">
                  <span class="h4 label">Attach supporting document</span>
                  <!-- <abbr class="required" title="(required)">*</abbr> -->
                  <small class="hint">This may be the Form 8 or other supporting document.</small>
                </legend>
                <input id="form8File" @change="handleUpload" type="file" name="form8File" :accept="uploads.acceptedTypes">
              </li>
              <li>
                <legend class="attachDocument">
                  <span class="h4 label">Attach additional supporting document</span>
                  <small class="hint">Such as evidence why the change is required.</small>
                </legend>
                <input id="supportingDocumentation" @change="handleUpload" type="file" name="supportingDocumentation"
                  :accept="uploads.acceptedTypes">
              </li>
            </ul>
          </fieldset>
        </li>
        <li id="uploading">
          <p v-if="uploading > 0">Uploading your attachment... ({{ uploads.uploading }} remaining)</p>
          <p v-else></p>
        </li>
        <li id="inProgress">
          <p v-if="inProgress">Submitting your request...</p>
          <p v-else> </p>
        </li>
        <li>
          <fieldset>
            <ul class="actions">
              <li>
                <strong><button :disabled="uploads.uploading > 0 || inProgress" id="submitButton">Submit request for
                    review of submitted death record</button></strong>
              </li>
            </ul>
          </fieldset>
        </li>
      </ol>
    </form>
    <hr />
  </div>
</template>

<script>
import sppapi from '../../sppapi.js';
import ClosureNotice from '../ClosureNotice.vue';

export default {
  name: 'TheReviewASubmittedDeathRecordForm',
  components: {
    ClosureNotice, //eslint-disable-line  vue/no-unused-components
  },
  data: function () {
    return {
      processId: 'reviewSubmittedDeathRec',
      form: {
        contactFirstName: '',
        contactFamilyName: '',
        contactOrganisationName: '',
        applicantPreferredContactEmail: '',
        applicantPreferredContactMobile: '',
        typeOfDeathRecordToReview: '',
        deliveryDetailsTheSame: '',
        deliveryFirstName: '',
        deliveryMiddleName: '',
        deliveryFamilyName: '',
        deliveryLine1: '',
        deliveryLine2: '',
        deliveryLine3: '',
        deliverySuburb: '',
        deliveryState: '',
        deliveryPostcode: '',
        deliveryCountry: '',
        deceasedFirstName: '',
        deceasedMiddleNames: '',
        deceasedFamilyName: '',
        deceasedDateOfDeath: '',
        deathRegistrationReference: '',
        informationIncorrectOrMissing: ''
      },
      contactPhone: '',
      contactEmail: '',
      inProgress: false,
      uploads: {
        uploadIds: [],
        uploading: 0,
        acceptedTypes: '.jpg, .tiff, .png, .jpeg, .pdf'
      },
    }
  },
  computed: {

  },
  methods: {
    removeUpload: function (event) {
      event.preventDefault()
      let targetUploadId = event.target.attributes['targetUpload'].value
      document.getElementById(targetUploadId).value = ''
      this.uploads.uploadIds = this.uploads.uploadIds.filter(uploadId => uploadId.fieldId !== targetUploadId)
      return false
    },
    uploadExists: function (fieldId) {
      return this.uploads.uploadIds.filter(uploadId => uploadId.fieldId == fieldId).length
    },
    handleUpload: function (event) {
      const selection = event.target.files[0]
      const ext = selection.name.split('.').pop();
      if (this.uploads.acceptedTypes.indexOf(ext) < 0) {
        document.getElementById(event.target.id).value = ''
        return
      }

      this.uploading++
      const reader = new FileReader()
      reader.onload = (e) => {
        sppapi.uploadFile(this, selection.name, event.srcElement.name, e.target.result)
      }
      reader.readAsDataURL(selection)
    },
    requiresUpload: function () {
      return this.form.typeOfDeathRecordToReview == 'correctionToExistingDeathCertificate';
    },
    submitForm: function (event) {
      event.preventDefault();
      this.contactPhone = this.form.applicantPreferredContactMobile;
      this.contactEmail = this.form.applicantPreferredContactEmail;

      if (!(this.form.contactFirstName && this.form.contactFamilyName && this.form.applicantPreferredContactMobile && this.form.applicantPreferredContactEmail
        && this.form.typeOfDeathRecordToReview && this.form.deceasedFirstName && this.form.deceasedFamilyName && this.form.deceasedDateOfDeath && this.form.deathRegistrationReference
        && this.form.informationIncorrectOrMissing)) {
        console.log('Missing contact info')
        return;
      }

      if (this.form.applicantPreferredContactMobile.length < 10) {
        return;
      }

      if (this.form.typeOfDeathRecordToReview == 'correctionToExistingDeathCertificate') {
        if (!(this.form.deliveryDetailsTheSame)) {
          console.log('Delivery same')
          return;
        }

        if (this.form.deliveryDetailsTheSame == 'false' &&
          !(this.form.deliveryFirstName && this.form.deliveryFamilyName && this.form.deliveryLine1 && this.form.deliverySuburb && this.form.deliveryState && this.form.deliveryPostcode)) {
          console.log('Missing delivery info')
          return;
        }
      }

      if (!this.requiresUpload()) {
        this.uploads.uploadIds = [];
      }

      sppapi.startProcessAndCompleteTask(this);
    }
  },
}

</script>

<style scoped lang="scss">
#inProgress {
  height: 1em;
}

#uploading {
  height: 1em;
}

.applicantPreferredContactEmail {
  width: 100%;
}

#supportingDocumentationFiles td {
  padding: 0 0 1.2em 0;
  background: white;
}

#supportingDocumentationFiles th {
  display: none;
}

.removeUpload {
  cursor: pointer;
}

.attachDocument {
  span {
    margin-bottom: 0em;
  }

  small {
    margin-bottom: 0.5em;
  }
}
</style>
